export default "__VITE_ASSET__DFXZunAa__"